// Most-recently-used currencies, capped at 3, persisted in localStorage.
// Read by both CurrencySelect (to render the top-3 section) and the tx
// modal (to default new tx to the user's last-used currency).

const KEY = 'gunsi_tally_recent_currencies'
export const RECENT_MAX = 3

export function loadRecentCurrencies() {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return []
    const arr = JSON.parse(raw)
    return Array.isArray(arr) ? arr.filter(s => typeof s === 'string') : []
  } catch { return [] }
}

export function pushRecentCurrency(code) {
  if (!code) return
  const list = loadRecentCurrencies().filter(c => c !== code)
  list.unshift(code)
  try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, RECENT_MAX))) } catch {}
}

// First item of the MRU list, or null. Convenience for callers that just
// want the "last currency you used".
export function lastUsedCurrency() {
  return loadRecentCurrencies()[0] ?? null
}
